export default "__VITE_ASSET__DMWNwc2h__"